module.exports = __webpack_public_path__ + "fonts/Outfit-Thin.8f281fc8.ttf";